import {
    PUSH_SUGGESTED_USERS,
    CLEAR_SUGGESTED_USERS,
    UPDATE_SUGGESTED_USER
} from "@/store/mutations.type"

const StateKey = 'suggestedUsers'

export default {
    [CLEAR_SUGGESTED_USERS](state) {
        state[StateKey] = []
        state[`${StateKey}Offset`] = 0
        state[`${StateKey}FetchCompleted`] = false
    },

    [PUSH_SUGGESTED_USERS](state, users) {
        
        if (users.length) {
            users.forEach((user) => {
                if (user) state[StateKey].push(user)
            })
        }
        if (users.length === state[`${StateKey}Limit`]) {
            state[`${StateKey}Offset`] += state[`${StateKey}Limit`]
        } else {
            state[`${StateKey}FetchCompleted`] = true
        }
    },

    [UPDATE_SUGGESTED_USER](state, payload) {
        const user = state[StateKey].find(user => user.id === payload.userId)
        if(user) Object.assign(user, payload.value)
    }
}